import React, { useEffect, useState } from "react";
import { Card, List, Button, Modal, Input, message, Spin, Tag } from "antd";
import axios from "axios";
import SummaryApi from "../../../common/index";
import "../../../Styles/SellerStylings/SellerQueries.css"; // add this file for custom styling

const { TextArea } = Input;

const SellerQueries = ({ seller, tabType }) => {
  const token = localStorage.getItem("token");

  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [messages, setMessages] = useState([]);
  const [replyText, setReplyText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  const statusColors = {
    open: "red",
    in_progress: "orange",
    resolved: "green",
    closed: "gray",
  };

  // Fetch seller queries
  const fetchQueries = async () => {
    try {
      setLoading(true);
      const url =
        tabType === "all"
          ? SummaryApi.getSellerQueries.url
          : SummaryApi.getSellerQueries.url + "?replied=true"; 
          console.log("Seller token:", token);

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setQueries(res.data.queries);
    } catch (err) {
      message.error("Failed to fetch queries");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueries();
  }, [tabType]);

  // Fetch messages for a query
  const fetchMessages = async (queryId) => {
    try {
      const res = await axios.get(
        SummaryApi.getQueryMessages(queryId).url,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setMessages(res.data.messages);
        setModalVisible(true);
      }
    } catch (err) {
      message.error("Failed to fetch messages");
      console.error(err);
    }
  };

  // Send reply
  const sendReply = async () => {
    if (!replyText.trim()) return message.warning("Reply cannot be empty");
    try {
      console.log("Seller token:", token);
       console.log("Sending:", { query_id: selectedQuery?.id, message: replyText });

      const res = await axios.post(
        SummaryApi.replyToQuery.url,
        {
          query_id: selectedQuery.id,
          message: replyText,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        message.success("Reply sent!");
        setReplyText("");
        fetchMessages(selectedQuery.id);
        fetchQueries();
      }
    } catch (err) {
      message.error("Failed to send reply");
      console.error(err);
    }
  };

  if (loading) return <Spin tip="Loading queries..." style={{ marginTop: 50 }} />;

  return (
    <div className="seller-queries-container">
      <h2 className="queries-heading">{tabType === "all" ? "All Queries" : "Replied Queries"}</h2>
     <List
  grid={{ gutter: 16, column: 1 }}
  dataSource={queries}
  renderItem={(query) => (
    <List.Item>
      <Card
        hoverable
        style={{ width: "100%" }}
        title={
          <div className="query-title">
            <span>{query.subject}</span>
            <Tag color={statusColors[query.status] || "blue"}>
              {query.status.toUpperCase()}
            </Tag>
          </div>
        }
      >
        {/* New section: User info */}
        <p>
          <strong>User:</strong> {query.user_name} <br />
          <strong>Email:</strong> {query.user_email} <br />
          <strong>Mobile:</strong> {query.user_mobile}
        </p>

        <p>
          <strong>Category:</strong> {query.category} |{" "}
          <strong>Messages:</strong> {query.message_count}
        </p>

        <Button
          type="primary"
          onClick={() => {
            setSelectedQuery(query);
            fetchMessages(query.id);
          }}
        >
          View & Reply
        </Button>
      </Card>
    </List.Item>
  )}
/>

      {/* Modal for messages */}
      <Modal
        title={`Query: ${selectedQuery?.subject}`}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={700}
      >
        <div className="chat-container">
          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`chat-bubble ${
                msg.sender_role === "seller" ? "seller-bubble" : "customer-bubble"
              }`}
            >
              <div className="sender-info">
                <strong>{msg.sender_name}</strong> ({msg.sender_role})
              </div>
              <div>{msg.message}</div>
            </div>
          ))}
        </div>

        <TextArea
          rows={3}
          placeholder="Type your reply..."
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
          style={{ marginTop: 10 }}
        />
        <Button
          type="primary"
          block
          style={{ marginTop: 10 }}
          onClick={sendReply}
        >
          Send Reply
        </Button>
      </Modal>
    </div>
  );
};

export default SellerQueries;
